// Shared, gesture-first discovery carousels. No transforms are applied to photography.
const configurations = [
  {root:'[data-u-choice-carousel]',viewport:'.u-choice',slide:'.u-choice__card',prev:'[data-u-choice-prev]',next:'[data-u-choice-next]',current:'[data-u-choice-current]',key:'discoveryKey'},
  {root:'[data-hl-sports-carousel]', viewport:'.hl-sports__viewport', slide:'[data-hl-sports-slide]', prev:'[data-hl-sports-prev]', next:'[data-hl-sports-next]', dot:'[data-hl-sports-dot]', current:'[data-hl-sports-current]', key:'hlSport'},
  {root:'[data-u-sector-carousel]', viewport:'.u-sector-showcase__viewport', slide:'[data-u-sector-slide]', prev:'[data-u-sector-prev]', next:'[data-u-sector-next]', dot:'[data-u-sector-dot]', current:'[data-u-sector-current]', key:'discoveryKey'},
  {root:'[data-u-product-carousel]', viewport:'.u-product-showcase__viewport', slide:'.u-category-card', prev:'[data-u-product-prev]', next:'[data-u-product-next]', dot:'[data-u-product-dot]', key:'discoveryKey'}
];
const tints = {gym:'#e8e5df',football:'#e1e9e1',running:'#e2e8ee',basketball:'#eee1d6',tennis:'#e5e9d8',more:'#e6e4df',corporate:'#dce1e4',hospitality:'#e7e0d7',hotel:'#dedbd5',health:'#dce7e4',industry:'#dddeda',logistics:'#dfe3e7'};
Object.assign(tints, {'t-shirt-polo':'#e2e3e0','polo-t-shirt':'#e2e3e0','camicie-maglieria':'#e5dfd8','felpe-pile-softshell':'#dce2e3','giacche-gilet':'#e2e0da','pantaloni-shorts':'#dddfe0','grembiuli-cucina':'#e6e1d8','medicale-beauty':'#dfe9e5','calzature-accessori':'#e0e2df'});
const instances = new Map();
function setup(root, config) {
  if(instances.has(root)) return;
  const viewport=root.querySelector(config.viewport), slides=[...root.querySelectorAll(config.slide)];
  if(!viewport || !slides.length) return;
  const abort=new AbortController(), options={signal:abort.signal};
  const prev=root.querySelector(config.prev), next=root.querySelector(config.next), dots=[...root.querySelectorAll(config.dot)], current=root.querySelector(config.current);
  const owner=root.closest('.u-section') || root;
  let motionVisible=false;
  const decorativeAnimations=new Map();
  const motionObjects=()=>[...owner.querySelectorAll('.hl-discovery-photo,.u-discovery-object')];
  const animateObjects=()=>{
    decorativeAnimations.forEach(animation=>animation.cancel());
    decorativeAnimations.clear();
    if(!motionVisible || reduced()) return;
    const key=owner.dataset.discoveryActive;
    const objects=motionObjects().filter(object=>object.dataset.discoveryObject===key || object.classList.contains(`hl-discovery-photo--${key}`));
    objects.forEach((object,i)=>{
      const lower=object.classList.contains('hl-discovery-photo--lower') || object.classList.contains('u-discovery-object--lower');
      const direction=lower?-1:1;
      const travel=matchMedia('(max-width: 749px)').matches?24:48;
      const animation=object.animate([
        {transform:`perspective(900px) translate3d(${direction*travel}px,${lower?travel:-travel}px,0) rotateZ(${direction*12}deg) rotateY(${direction*18}deg) scale(.88)`},
        {transform:`perspective(900px) translate3d(${-direction*4}px,${lower?-3:3}px,0) rotateZ(${-direction*2}deg) rotateY(0deg) scale(1.025)`,offset:.76},
        {transform:'none'}
      ],{duration:850,delay:i*85,easing:'cubic-bezier(.22,.7,.2,1)',fill:'backwards'});
      decorativeAnimations.set(object,animation);
    });
  };
  let active=-1, frame=0, targetIndex=null, settleTimer=0;
  const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
  const rtl=()=>getComputedStyle(viewport).direction==='rtl';
  const measure=()=>{
    frame=0;
    const bounds=viewport.getBoundingClientRect(), reversed=rtl();
    const edge=reversed?bounds.right:bounds.left;
    let index=0, distance=Infinity;
    slides.forEach((slide,i)=>{const rect=slide.getBoundingClientRect();const d=Math.abs((reversed?rect.right:rect.left)-edge);if(d<distance){distance=d;index=i;}});
    // The last card cannot align to the leading edge when several cards fit.
    const last=slides.at(-1).getBoundingClientRect();
    if(viewport.scrollWidth>viewport.clientWidth+2 && Math.abs((reversed?last.left-bounds.left:last.right-bounds.right))<3) index=slides.length-1;
    if(index===active) return;
    active=index;
    const key=slides[index].dataset[config.key] || '';
    owner.dataset.discoveryActive=key;
    motionObjects().forEach(object=>object.classList.toggle('is-discovery-object-active',object.dataset.discoveryObject===key));
    owner.style.setProperty('--hl-discovery-tint', tints[key] || '#e5e3de');
    if(config.key==='hlSport') root.dataset.activeSport=key;
    slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===index));
    dots.forEach((dot,i)=>{dot.classList.toggle('is-active',i===index);if(i===index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
    if(current) current.textContent=config.root==='[data-u-choice-carousel]' ? `${String(index+1).padStart(2,'0')} / 02` : String(index+1).padStart(2,'0');
    if(prev) prev.disabled=index===0;
    if(next) next.disabled=index===slides.length-1;
    animateObjects();
  };
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(measure);};
  const go=(index)=>{
    targetIndex=Math.max(0,Math.min(index,slides.length-1));
    const card=slides[targetIndex].getBoundingClientRect(), bounds=viewport.getBoundingClientRect();
    const difference=rtl()?card.right-bounds.right:card.left-bounds.left;
    viewport.scrollBy({left:difference,behavior:reduced()?'instant':'smooth'});
  };
  prev?.addEventListener('click',()=>go((targetIndex??active)-1),options);
  next?.addEventListener('click',()=>go((targetIndex??active)+1),options);
  dots.forEach((dot,i)=>dot.addEventListener('click',()=>go(i),options));
  viewport.addEventListener('scroll',()=>{schedule();clearTimeout(settleTimer);settleTimer=setTimeout(()=>{targetIndex=null;measure();},180);},{...options,passive:true});
  viewport.addEventListener('scrollend',()=>{targetIndex=null;schedule();},options);
  viewport.addEventListener('pointerdown',()=>{targetIndex=null;},options);
  viewport.addEventListener('wheel',()=>{targetIndex=null;},{...options,passive:true});
  viewport.addEventListener('keydown',event=>{
    if(event.target!==viewport || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    go(event.key==='Home'?0:event.key==='End'?slides.length-1:active+((event.key==='ArrowRight')!==rtl()?1:-1));
  },options);
  const resize=new ResizeObserver(schedule); resize.observe(viewport);
  const visibility=new IntersectionObserver(entries=>{
    const visible=entries[0].isIntersecting;
    if(visible && !motionVisible){motionVisible=true;animateObjects();}
    else if(!visible) motionVisible=false;
  },{threshold:.15});
  visibility.observe(root);
  const motionPreference=matchMedia('(prefers-reduced-motion: reduce)');
  motionPreference.addEventListener('change',()=>{if(reduced()){decorativeAnimations.forEach(animation=>animation.cancel());decorativeAnimations.clear();}},options);
  instances.set(root,()=>{abort.abort();resize.disconnect();visibility.disconnect();decorativeAnimations.forEach(animation=>animation.cancel());cancelAnimationFrame(frame);clearTimeout(settleTimer);instances.delete(root);});
  measure();
}
function initialize(scope=document){configurations.forEach(config=>{if(scope.matches?.(config.root))setup(scope,config);scope.querySelectorAll(config.root).forEach(root=>setup(root,config));});}
initialize();
// Native details state is authoritative, including on mobile Safari.
// Keep the drawer visible even when its animation/controller initializes late.
document.addEventListener('toggle', event => {
  const details = event.target;
  if (!(details instanceof HTMLDetailsElement) || !details.matches('header-drawer > .menu-drawer-container')) return;
  details.classList.toggle('menu-open', details.open);
  details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
  document.body.classList.toggle('hl-mobile-menu-open', Boolean(document.querySelector('header-drawer > .menu-drawer-container[open]')));
}, true);
document.addEventListener('shopify:section:load',event=>initialize(event.target));
document.addEventListener('shopify:section:unload',event=>{for(const[root,destroy]of instances)if(event.target.contains(root))destroy();});
